'use client'

import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import { useEffect, useRef } from 'react'

interface Props {
  eventName: string
  eventProperties: object
}

const AmplitudePageLogger = ({ eventName, eventProperties }: Props) => {
  const { amplitude } = useAmplitude()

  const hasTriggeredEvent = useRef(false)

  const logAmplitudeEventOnce = ({ eventName, eventProperties }: Props) => {
    if (!amplitude || hasTriggeredEvent.current) return
    amplitude.logEvent(eventName, eventProperties)
    hasTriggeredEvent.current = true
  }

  useEffect(() => {
    if (!amplitude) return
    logAmplitudeEventOnce({ eventName, eventProperties })
  }, [amplitude])

  return null
}

export default AmplitudePageLogger
